import React from 'react'

import ListPlaceholder from 'src/ui/List/ListPlaceholder'

import UnitDetailSkeleton from './UnitDetailSkeleton'
import UnitInfoPlaceholder from './subcomponents/UnitInfo/UnitInfoPlaceholder'
import UnitExercisesPreviewPlaceholder from './subcomponents/UnitExercisesPreview/UnitExercisesPreviewPlaceholder'

const UnitDetailPlaceholder = () => {
  return (
    <UnitDetailSkeleton
      unitSection={<UnitInfoPlaceholder />}
      exercisesSection={<UnitExercisesPreviewPlaceholder />}
      listSection={<ListPlaceholder />}
    />
  )
}

export default UnitDetailPlaceholder
